<template>
  <v-card elevation="5" width="350" max-height="350" class="color-pickar__card overflow-x-hidden">
    <v-card-text class="px-2 py-0 mr-1">
      <div v-if="selectedBackdropOption === 0">
        <v-row class="pb-1">
          <v-col cols="10" class="column__padding">
            <p class="text-subtitle-1 font-weight-bold mt-2">Image</p>
          </v-col>
          <v-col cols="2" class="d-flex justify-end pr-2" v-if="false">
            <v-btn
              icon="mdi-tray-arrow-up"
              @click.stop="triggerFileInput"
              rounded="lg"
              size="32"
              class="mt-1"
              variant="tonal"
              :disabled="isFileUploading"
            ></v-btn>
            <v-file-input
              ref="fileInput"
              v-model="selectedFile"
              accept="image/jpeg, image/png, image/avif"
              variant="outlined"
              density="comfortable"
              class="d-none"
              hide-details
              :multiple="false"
              :error-messages="fileError"
              @change="handleFileUpload"
            ></v-file-input>
          </v-col>
        </v-row>
        <v-row class="ml-1 mt-1">
          <v-col
            v-for="(img, index) in aiBackgroundImages"
            :key="index"
            cols="4"
            class="pl-1 pr-2 pt-0 ma-0"
          >
            <v-card
              variant="outlined"
              @click.stop="selectNewImage(index)"
              v-model="selectedImageIndex"
              :class="{
                'border-md border-opacity-100 border-primary': selectedImageIndex === index,
              }"
            >
              <v-img :src="img" contain height="61" crossorigin="anonymous"></v-img>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div v-if="selectedBackdropOption === 1">
        <p class="text-subtitle-1 font-weight-bold mt-2 ml-1">Background</p>
        <v-row no-gutters class="align-center mb-0 pb-0">
          <v-col cols="auto">
            <v-color-picker
              elevation="0"
              class="color-picker__class"
              v-model="newBackgroundColor"
              mode="hex"
              :modes="['hex']"
              hide-inputs
              hide-canvas
            ></v-color-picker>
          </v-col>
          <v-col cols="auto">
            <v-select
              v-model="selectedBackgroundColorCode"
              variant="solo-filled"
              density="compact"
              flat
              item-value="id"
              item-title="code"
              hide-details
              :items="colorCodeTypes"
            ></v-select>
          </v-col>
          <v-col class="ml-4" cols="4">
            <v-text-field
              v-model="backgroundColor"
              variant="solo-filled"
              flat
              density="compact"
              hide-details
              :prefix="selectedBackgroundColorCode === colorCodes.HEX ? '#' : undefined"
            ></v-text-field>
          </v-col>
          <v-col class="ml-4">
            <v-menu
              v-model="backgroundMenu"
              :close-on-content-click="false"
              location="end"
              offset="8"
            >
              <!-- Activator -->
              <template #activator="{ props }">
                <v-btn v-bind="props" :color="newBackgroundColor" rounded="1" size="36"> </v-btn>
              </template>

              <!-- Menu Content -->
              <v-card>
                <v-color-picker
                  class="color-picker__menu"
                  v-model="newBackgroundColor"
                  mode="rgba"
                  hide-inputs
                  flat
                ></v-color-picker>
              </v-card>
            </v-menu>
          </v-col>
        </v-row>
      </div>

      <p class="text-subtitle-1 font-weight-bold ml-1 mt-2">Text</p>
      <v-row no-gutters class="align-center">
        <v-col cols="auto">
          <v-color-picker
            elevation="0"
            class="color-picker__class"
            v-model="newTextColor"
            mode="hex"
            :modes="['hex']"
            hide-inputs
            hide-canvas
          ></v-color-picker>
        </v-col>
        <v-col cols="auto">
          <v-select
            v-model="selectedTextColorCode"
            variant="solo-filled"
            density="compact"
            flat
            item-value="id"
            item-title="code"
            hide-details
            :items="colorCodeTypes"
          ></v-select>
        </v-col>
        <v-col class="ml-4" cols="4">
          <v-text-field
            v-model="textColor"
            variant="solo-filled"
            flat
            density="compact"
            hide-details
            :prefix="selectedTextColorCode === colorCodes.HEX ? '#' : undefined"
          ></v-text-field>
        </v-col>
        <v-col class="ml-4">
          <v-menu v-model="textMenu" :close-on-content-click="false" location="end" offset="8">
            <!-- Activator -->
            <template #activator="{ props }">
              <v-btn v-bind="props" :color="newTextColor" rounded="1" size="36"> </v-btn>
            </template>

            <!-- Menu Content -->
            <v-card>
              <v-color-picker
                class="color-picker__menu"
                variant="outlined"
                v-model="newTextColor"
                mode="rgba"
                hide-inputs
                flat
              ></v-color-picker>
            </v-card>
          </v-menu>
        </v-col>
      </v-row>
      <p class="text-subtitle-1 font-weight-bold ml-1 pl-0 mt-2">Texture</p>
      <v-row class="ml-1 mt-1">
        <template v-for="(img, index) in backgroundImages" :key="index">
          <v-col v-if="!hiddenIndexs.includes(index)" cols="4" class="pl-1 pr-2 pt-0 ma-0">
            <v-card
              variant="outlined"
              @click.stop="selectNewTexture(index)"
              v-model="selectedTextureIndex"
              :class="{
                'border-md border-opacity-100 border-primary': selectedTextureIndex === index,
              }"
            >
              <v-img
                :src="img"
                contain
                height="61"
                crossorigin="anonymous"
                :class="selectedBackdropOption === 0 && index != 0 ? 'coloring-class' : ''"
              ></v-img>
            </v-card>
          </v-col>
        </template>
      </v-row>
    </v-card-text>
    <v-card-actions class="d-flex justify-end card_action__class">
      <v-btn variant="text" color="grey" @click.stop="closeMenu">Close</v-btn>
      <v-btn
        variant="tonal"
        color="primary"
        @click.stop="addNewBackDrop"
        :disabled="checkForBackdrop"
        >{{ props.edit === true ? 'Save' : 'Add' }}</v-btn
      >
    </v-card-actions>
  </v-card>
</template>
<script setup lang="ts">
import s3Folders from '@/constants/s3Folders'
import { getContrastColor, getImageDimensionsFromFile, uploadToS3 } from '@/helpers/commonHelper'
import { computed, onMounted, ref, watch } from 'vue'
import { usePlacementStore } from '@/stores/placement'
import { useBrandStore } from '@/stores/brand'
import { useI18n } from 'vue-i18n'
import { PLACEMENT_TYPES } from '@/constants/positions'
import { hexToRgb, rgbToHex } from '@/helpers/colorHelper'
import { overlays } from '@/helpers/backgroundHelper'
import { useEditorStore } from '@/stores/editor'
const { t } = useI18n()
const props = defineProps<{
  selectedBackdropOption: number
  newBackgroundColor: string
  newTextColor: string
  textureIndex?: number | null
  imageIndex?: number | null
  edit?: boolean
  colorCode?: number
}>()
const emit = defineEmits(['addBackdrop', 'updateBackdrop', 'updateBackground', 'closeMenu'])
const fileInput = ref<HTMLInputElement | null>(null)
const selectedFile = ref<File | null>(null)
const fileError = ref<string | null>(null)
const placementStore = usePlacementStore()
const brandStore = useBrandStore()
const editorStore = useEditorStore()
const selectedImageIndex = ref<number | null>(props.imageIndex ?? null)
const selectedTextureIndex = ref<number | null>(props.textureIndex ?? null)
const isFileUploading = ref<boolean>(false)
const bgErrorMessage = ref<string>('')
const isTextColorManuallySet = ref(false)
const isBackgroundColorConverted = ref(false)

const colorCodes = {
  HEX: 'Hex',
  RGB: 'RGB',
}
const colorCodeTypes = [colorCodes.HEX, colorCodes.RGB]
const newBackgroundColor = ref<string>(props.newBackgroundColor)
const newTextColor = ref<string>(props.newTextColor)

const selectedBackgroundColorCode = ref(colorCodes.HEX)

const selectedTextColorCode = ref(colorCodes.HEX)

const specialPlacements = [PLACEMENT_TYPES.FRONT, PLACEMENT_TYPES.STAIRCASE, PLACEMENT_TYPES.LAYER]
const backgroundMenu = ref<boolean>(false)
const textMenu = ref<boolean>(false)

const selectedBackdropOption = computed(() => props.selectedBackdropOption)
const aiBackgroundImages = computed(() => placementStore.aiBackgroundImages)
const backgroundImages = computed(() => {
  if (selectedBackdropOption.value === 0) {
    return overlays
  }
  return placementStore.backgroundImages
})
const hiddenIndexs = computed(() => {
  if (selectedBackdropOption.value === 0) {
    return []
  }
  if (
    specialPlacements.includes(placementStore.selectedPlacementOption) &&
    selectedBackdropOption.value === 1
  ) {
    return []
  } else {
    return [1, 2]
  }
})

const backgroundColor = computed({
  get: () => {
    if (selectedBackgroundColorCode.value === colorCodes.HEX) {
      return newBackgroundColor.value.slice(1).toUpperCase()
    } else {
      return newBackgroundColor.value
    }
  },
  set: (color: string) => {
    if (selectedBackgroundColorCode.value === colorCodes.HEX) {
      newBackgroundColor.value = '#' + color
    } else {
      newBackgroundColor.value = color
    }
  },
})

const textColor = computed({
  get: () => {
    if (selectedTextColorCode.value === colorCodes.HEX) {
      return newTextColor.value.slice(1).toUpperCase()
    } else {
      return newTextColor.value
    }
  },
  set: (color: string) => {
    if (selectedTextColorCode.value === colorCodes.HEX) {
      newTextColor.value = '#' + color
    } else {
      newTextColor.value = color
    }
  },
})

const checkForBackdrop = computed(() => {
  if (selectedBackdropOption.value === 0) {
    return selectedImageIndex.value === null || selectedTextureIndex.value === null ? true : false
  }
  return selectedTextureIndex.value === null ? true : false
})

const triggerFileInput = () => {
  fileInput.value?.click()
}
const closeMenu = () => {
  emit('closeMenu')
}
const handleFileUpload = () => {
  if (selectedFile.value) {
    const allowedTypes = ['image/jpeg', 'image/png', 'image/avif']
    const allowedExtensions = ['jpg', 'jpeg', 'png', 'avif']

    const fileType = selectedFile.value.type
    const fileExtension = selectedFile.value.name.split('.').pop()?.toLowerCase()

    if (
      !allowedTypes.includes(fileType) ||
      !fileExtension ||
      !allowedExtensions.includes(fileExtension)
    ) {
      fileError.value = t('errors.onlyImageFilesAllowed')
      selectedFile.value = null
      return
    }

    fileError.value = null
    handleUpload(selectedFile.value)
    selectedFile.value = null
  }
}

const handleUpload = async (file: File | null) => {
  if (!file) return
  isFileUploading.value = true
  const extension = file.name.split('.').pop()

  const size = placementStore.selectedPlacement?.creativeSetGuidelines.ad_size
  if (!size) {
    console.error('Placement size guidelines not found.')
    return
  }

  try {
    const imageSize = await getImageDimensionsFromFile(file)

    if (imageSize.width !== size.width || imageSize.height !== size.height) {
      bgErrorMessage.value = `Uploaded image size does not match required dimensions (${size.width}x${size.height}).`
      return
    }

    const backgroundImage = await uploadToS3(
      file,
      s3Folders.backgroundTextures,
      `backgroundTexture-${Date.now()}.${extension}`,
    )
    placementStore.addAiBackgroundImage(backgroundImage)
    selectedImageIndex.value = aiBackgroundImages.value.length - 1
  } catch (error) {
    throw error
  } finally {
    isFileUploading.value = false
  }
}

const selectNewImage = (index: number) => {
  if (selectedImageIndex.value === index) {
    selectedImageIndex.value = null
    return
  }
  selectedImageIndex.value = index
}

const selectNewTexture = (index: number) => {
  if (selectedTextureIndex.value === index) {
    selectedTextureIndex.value = null
    return
  }
  selectedTextureIndex.value = index
}

const parseRgbString = (rgbStr: string) => {
  const match = rgbStr.replace(/\s+/g, '').match(/^rgb?\((\d+),(\d+),(\d+)(?:,([\d.]+))?\)$/i)
  if (!match) return null
  const [, r, g, b] = match
  return {
    r: Number(r),
    g: Number(g),
    b: Number(b),
  }
}

const addNewBackDrop = () => {
  if (selectedBackdropOption.value === 1) {
    const newBackDrop = {
      backgroundColor: newBackgroundColor.value,
      textColor: newTextColor.value,
      backgroundTextureIndex: selectedTextureIndex.value ?? 0,
      logoInfo: [],
    }
    if (props.edit === true) {
      emit('updateBackdrop', newBackDrop)
    } else {
      emit('addBackdrop', newBackDrop)
    }
  } else {
    const newBackGround = {
      backgroundImageIndex: selectedImageIndex.value ?? 0,
      textColor: newTextColor.value,
      backgroundTextureIndex: selectedTextureIndex.value,
      backgroundColor: '',
      logoInfo: [],
    }
    if (props.edit === true) {
      if (editorStore.selectedBackGroundIndex != null) {
        const background = editorStore.createdBackGrounds[editorStore.selectedBackGroundIndex]
        newBackGround.backgroundColor = background.backgroundColor
      }
      emit('updateBackground', newBackGround)
    } else {
      emit('addBackdrop', newBackGround)
    }
  }
}

let oldValue = ''
watch(newBackgroundColor, (value, beforeValue) => {
  if (oldValue != value && selectedBackdropOption.value == 1) {
    const backgroundColors = brandStore.selectedBrand?.colours.map((item) => item) ?? []
    if (!isTextColorManuallySet.value && value.length >= 7 && !isBackgroundColorConverted.value) {
      newTextColor.value = getContrastColor(value, backgroundColors)
    }
    if (selectedBackgroundColorCode.value == colorCodes.RGB) {
      oldValue = value
      const rgb: any = hexToRgb(value)
      if (rgb) {
        const rgbcolor = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
        oldValue = rgbcolor
        newBackgroundColor.value = rgbcolor
      }
    }
  } else {
    oldValue = ''
  }
  isBackgroundColorConverted.value = false
})

watch(newTextColor, (value, old) => {
  if (old !== undefined && value !== old) {
    isTextColorManuallySet.value = true
  }
  if (selectedTextColorCode.value == colorCodes.RGB) {
    const rgb: any = hexToRgb(value)
    if (rgb) {
      newTextColor.value = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
    }
  }
})

watch(selectedTextColorCode, (value) => {
  if (value == colorCodes.HEX) {
    const color = parseRgbString(newTextColor.value)
    if (color) {
      newTextColor.value = rgbToHex(color?.r, color?.g, color.b)
    }
  } else if (value == colorCodes.RGB) {
    const rgb: any = hexToRgb(newTextColor.value)
    if(rgb){
      newTextColor.value = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
    }
  }
})

watch(selectedBackgroundColorCode, (value) => {
  if (value == colorCodes.HEX) {
    const color = parseRgbString(newBackgroundColor.value)
    if (color) {
      newBackgroundColor.value = rgbToHex(color?.r, color?.g, color.b)
    }
  } else if (value == colorCodes.RGB) {
    const rgb: any = hexToRgb(newBackgroundColor.value)
    newBackgroundColor.value = `rgb(${rgb.r}, ${rgb.g}, ${rgb.b})`
  }
  isBackgroundColorConverted.value = true
})

onMounted(() => {
  if (props.colorCode === undefined && brandStore.selectedTextColorType == 1) {
    selectedTextColorCode.value = colorCodes.RGB
  }
  if (props.colorCode === undefined && brandStore.selectedBackgroundColorType == 1) {
    selectedBackgroundColorCode.value = colorCodes.RGB
  }
})
</script>
<style scoped>
:deep(.color-picker__class .v-color-picker-preview__sliders) {
  display: none;
}

:deep(.color-picker__menu .v-color-picker-preview__dot) {
  display: none;
}

:deep(.color-picker__menu .v-color-picker-preview__eye-dropper) {
  display: none;
}

:deep(.v-color-picker-preview__alpha) {
  display: none;
}

:deep(.color-picker__class .v-color-picker__controls) {
  padding-left: 2px;
  padding-right: 0;
  padding-top: 0;
  padding-bottom: 0px;
}

.color-picker__class {
  max-width: 50px !important;
}

.coloring-class {
  background-color: '#000000';
  filter: invert(1);
}
</style>
